// extracted by mini-css-extract-plugin
export default {"container":"cubes_container__iyQUQ","cubes":"cubes_cubes__ZeLR3","cube":"cubes_cube__RTbGh"};